const doc = [({"en":({"js":({"merfoto":({"orders":({"table":({"quantity_sum":"Quantity sum"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;